<template>
    <div>
        <base-modal id="modalContactPhone">
            <div class="modal-header">
                <user-picture :size="'-medium'" :border="'-border-light'" :user="user" v-if="user" />

                <h2 class="title">Contato <span class="color-alt">por Telefone</span></h2>
                <p class="subtitle">Informe os seus dados no formulário</p>
                <i class="icon far fa-headset" aria-hidden="true"></i>
            </div>
            <div class="modal-body">
                <slot />

                <form class="form form-flex">
                    <div class="input-group">
                        <input class="input -xlarge" type="text" v-model="name" placeholder="Qual seu nome?" />
                    </div>
                    <div class="input-group form-row">
                        <input
                            class="input -xlarge"
                            type="tel"
                            v-model="mobilePhone"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            placeholder="Celular"
                        />
                        <input
                            class="input -xlarge"
                            type="tel"
                            v-model="phone"
                            v-mask="'(##) ####-####'"
                            placeholder="Telefone fixo"
                        />
                    </div>
                    <div class="input-group">
                        <textarea
                            class="input -xlarge"
                            type="text"
                            v-model="message"
                            placeholder="Por favor, me ligue quarta-feira entre as 14:00 e as 16:00 horas. Tenho interesse no imóvel Park House Residence."
                        ></textarea>
                    </div>
                    <div class="actions">
                        <button class="button -block -xlarge -contrast" type="button">
                            Enviar
                        </button>
                    </div>
                </form>
            </div>
        </base-modal>
    </div>
</template>

<script>
    import BaseModal from '@/Components/BaseModal'
    import UserPicture from '@/Components/User/UserPicture'

    export default {
        components: {
            BaseModal,
            UserPicture,
        },

        props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },
        },

        data() {
            return {
                name: null,
                phone: null,
                mobilePhone: null,
                email: null,
                message: null,
            }
        },

        computed: {
        },

        methods: {
            close() {
                this.$root.$emit('hideModal', 'modalContactPhone')
            },

            notification() {
                this.close()
                this.$root.$emit('showModal', 'modalContactNotification')
            },
        },
    }
</script>

<style lang="stylus" scoped></style>
